import { Component, OnInit, ViewChild } from '@angular/core';
import { IOption } from 'ng-select';
import { Http } from '@angular/http';
import { ToastyService, ToastOptions, ToastData } from 'ng2-toasty';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment/moment';
import { DialogService } from 'ng2-bootstrap-modal';
import { AlertComponent } from './../alert/alert.component';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { Popup } from 'ng2-opd-popup';

@Component({
  selector: 'app-sublocality',
  templateUrl: './sublocality.component.html',
  styleUrls: ['./sublocality.component.scss']
})
export class SublocalityComponent implements OnInit {
  loading: boolean = true;
  isEmiratesLoaded: boolean = false;
  isSublocalityListLoaded: boolean = false;
  isDeleteAvailabilityLoaded: boolean = false;
  ToolTip = 'Delete is not allowed since it is used in contract registration page';
  @ViewChild('Askdelete') Askdelete: Popup;
  @ViewChild('delete') delete: Popup;
  deleteId: any;
  msgtext: string = '';
  startingCount: number = 0;
  endingCount: number = 0;
  p: number = 1;
  inputvalidate: boolean = false;
  newEmirate_err: boolean = false;
  ListofSublocality: any[] = [];
  mapVisible: boolean = false;
  emiratesedit: string = 'Select the Emirates';
  emirates: any = '';
  myFormsOptions: Array<IOption> = [];
  ListEmiratesdetails: any[] = [];
  orgId: number;
  userId: number;
  alerttxt: string = '';
  latitude: any;
  longitude: any;
  userSettings = {};
  location: any;
  lat: number = 25.190519127063453;
  lng: number = 55.393190206959844;
  lat1: number;
  lng1: number;
  expanded: boolean = false;
  zoomIn = 12;
  searchLocation: any;
  btnName: string = 'Submit';
  EditObjectId: any;
  Emiratelng: any = null;
  Emiratelat: any = null;
  Sublocationlat: any = null;
  Sublocationlng: any = null;
  search: any;

  constructor(
    private dialogService: DialogService,
    private http: Http,
    private toastyservice: ToastyService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.loading = true;
    this.isEmiratesLoaded = false;
    this.isSublocalityListLoaded = false;
    this.isDeleteAvailabilityLoaded = false;
    if (this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null) {
      window.location.href = 'https://still.alshirawi.com/highmessaging/';
    } else {
      this.orgId = this.route.params['value'].orgId;
      this.userId = this.route.params['value'].userId;
      console.log('OrgId ' + this.orgId);
      console.log('UserId ' + this.userId);
    }
    this.getemiratesdetails();
  }

  updateLoadingState() {
    this.loading = !(this.isEmiratesLoaded && this.isSublocalityListLoaded && this.isDeleteAvailabilityLoaded);
  }

  normalizeSublocalityName(value: any): string {
    return String(value || '').trim().toLowerCase();
  }

  showDuplicateDialog(message: string) {
    this.dialogService.addDialog(AlertComponent, { title: 'DUPLICATE SUBLOCALITY', message: message });
  }

  alert() {
  }

  onAddressSearchChange(address: Address) {
    this.inputvalidate = false;
    this.location = address.address_components[0].long_name;
    this.Sublocationlat = address.geometry.location.lat();
    this.Sublocationlng = address.geometry.location.lng();
    this.validate(this.location);
  }

  deleteOk() {
    this.delete.hide();
  }

  getCount() {
    if (this.p < Math.ceil(this.ListofSublocality.length / 10)) {
      this.startingCount = (this.p - 1) * 10;
      if (this.startingCount == 0) {
        this.startingCount = 1;
      }
      this.endingCount = this.p * 10;
    } else if (this.p == Math.ceil(this.ListofSublocality.length / 10)) {
      let count = this.ListofSublocality.length % 10;
      this.startingCount = (this.p - 1) * 10;
      this.endingCount = this.startingCount + count;
      if (this.startingCount == 0) {
        this.startingCount = 1;
        this.endingCount = count;
      }
    }
  }

  getemiratesdetails() {
    let emiratesObj = {
      'orgId': this.orgId
    };
    return this.http.post('/api/getEmiratesdetails', emiratesObj).subscribe(res => {
      let responseEmirates = res.json();
      this.ListEmiratesdetails = responseEmirates.result_data || [];
      let pusharr = [];
      for (let i = 0; i < this.ListEmiratesdetails.length; i++) {
        pusharr.push({ 'value': this.ListEmiratesdetails[i]._id.toString(), 'label': this.ListEmiratesdetails[i].emirates.toUpperCase() });
      }
      this.myFormsOptions = pusharr;
      this.isEmiratesLoaded = true;
      if (this.ListEmiratesdetails.length > 0) {
        this.getAllSublocalitydetails();
      } else {
        this.isSublocalityListLoaded = true;
        this.isDeleteAvailabilityLoaded = true;
        this.updateLoadingState();
      }
    }, err => {
      this.isEmiratesLoaded = true;
      this.isSublocalityListLoaded = true;
      this.isDeleteAvailabilityLoaded = true;
      this.updateLoadingState();
      if (err.status != 200) {
        this.alerttxt = 'Unable to load the Emirates value';
        this.getWarningFunction(this.alerttxt);
      }
    });
  }

  getAllSublocalitydetails() {
    this.loading = true;
    this.isSublocalityListLoaded = false;
    this.isDeleteAvailabilityLoaded = false;
    let makeObj = {
      'orgId': this.orgId
    };
    return this.http.post('/api/getSubLocalitydetails', makeObj).subscribe(res => {
      let Response = res.json();
      this.ListofSublocality = (Response.result_data || []).map((sublocality: any) => ({
        ...sublocality,
        status: false,
        deleteBlockedReason: ''
      }));
      if (this.ListofSublocality.length > 0) {
        for (let subL = 0; subL < this.ListofSublocality.length; subL++) {
          for (let E = 0; E < this.ListEmiratesdetails.length; E++) {
            if (this.ListEmiratesdetails[E]._id == this.ListofSublocality[subL].emirateid) {
              this.ListofSublocality[subL].emirateName = this.ListEmiratesdetails[E].emirates;
            }
          }
        }
        this.getCount();
        this.isSublocalityListLoaded = true;
        this.loadDeleteAvailability();
      } else {
        this.isSublocalityListLoaded = true;
        this.isDeleteAvailabilityLoaded = true;
        this.updateLoadingState();
      }
      console.log('ListofSublocality', this.ListofSublocality);
    }, err => {
      this.isSublocalityListLoaded = true;
      this.isDeleteAvailabilityLoaded = true;
      this.updateLoadingState();
      if (err.status != 200) {
        this.alerttxt = 'Unable to load the Value';
        this.getWarningFunction(this.alerttxt);
      }
    });
  }

  loadDeleteAvailability() {
    let sublocalityIds: any[] = [];

    for (let i = 0; i < this.ListofSublocality.length; i++) {
      this.ListofSublocality[i].status = false;
      this.ListofSublocality[i].deleteBlockedReason = '';
      sublocalityIds.push(this.ListofSublocality[i]._id);
    }

    return this.http.post('/api/getSublocalityDeleteAvailability', {
      'ids': sublocalityIds,
      'orgId': this.orgId
    }).subscribe(res => {
      let availabilityResponse = res.json().availability || {};

      for (let i = 0; i < this.ListofSublocality.length; i++) {
        if (availabilityResponse[String(this.ListofSublocality[i]._id)] && availabilityResponse[String(this.ListofSublocality[i]._id)].canDelete === false) {
          this.ListofSublocality[i].status = true;
          this.ListofSublocality[i].deleteBlockedReason = availabilityResponse[String(this.ListofSublocality[i]._id)].reason || this.ToolTip;
        }
      }

      this.isDeleteAvailabilityLoaded = true;
      this.updateLoadingState();
    }, err => {
      this.isDeleteAvailabilityLoaded = true;
      this.updateLoadingState();
      if (err.status != 200) {
        this.msgtext = 'Unable to validate delete availability';
        this.getWarningFunction(this.msgtext);
      }
    });
  }

  getEmiratedetails(value) {
    this.expanded = true;
    for (let i = 0; i < this.ListEmiratesdetails.length; i++) {
      if (this.ListEmiratesdetails[i]._id == value) {
        this.lat = parseFloat(this.ListEmiratesdetails[i].latitude);
        this.lng = parseFloat(this.ListEmiratesdetails[i].longitude);
      }
    }
  }

  validate(val) {
    if (this.normalizeSublocalityName(this.location) === '') {
      this.inputvalidate = true;
    } else {
      this.inputvalidate = false;
    }
  }

  reset() {
    this.emiratesedit = 'Select the Emirates';
    this.emirates = '';
    this.location = '';
    this.expanded = false;
    this.mapVisible = false;
    this.btnName = 'Submit';
    this.EditObjectId = '';
    this.newEmirate_err = false;
    this.inputvalidate = false;
    this.lat1 = null;
    this.lng1 = null;
    this.Sublocationlat = null;
    this.Sublocationlng = null;
  }

  toggle() {
    this.expanded = !this.expanded;
    if (this.expanded == true) {
      this.mapVisible = true;
    } else if (this.expanded == false) {
      this.mapVisible = false;
    }
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  mapClicked(Event) {
    this.latitude = Event.coords.lat;
    this.longitude = Event.coords.lng;

    return this.http.get('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + Event.coords.lat + ',' + Event.coords.lng + '%20&key=AIzaSyCTK07AppZAiE0nxsrCtgjK37aGiwv-dqc').subscribe(res => {
      let response = res.json();
      this.location = response.results[0].address_components[1].short_name;
      this.Sublocationlat = response.results[0].geometry.location.lat;
      this.Sublocationlng = response.results[0].geometry.location.lng;

      for (let m = 0; m < response.results[0].address_components.length; m++) {
        for (let t = 0; t < response.results[0].address_components[m].types.length; t++) {
          if (response.results[0].address_components[m].types[t] == 'sublocality' || response.results[0].address_components[m].types[t] == 'sublocality_level_1' || response.results[0].address_components[m].types[t] == 'locality') {
            this.location = response.results[0].address_components[m].short_name;
            break;
          }
        }
      }
      this.validate(this.location);
    });
  }

  getWarningFunction(err) {
    var toastOptions: ToastOptions = {
      title: 'Sublocality',
      msg: err,
      showClose: true,
      timeout: 3000,
      theme: 'bootstrap',
      onAdd: (toast: ToastData) => {
      },
      onRemove: function(toast: ToastData) {
      }
    };
    this.toastyservice.warning(toastOptions);
  }

  showAlertForAddingdata() {
    this.dialogService.addDialog(AlertComponent, { title: 'ADD SUBLOCALITY ', message: 'The Data Added Successfully' });
  }

  showAlertForUpdatingdata() {
    this.dialogService.addDialog(AlertComponent, { title: 'UPDATE SUBLOCALITY', message: 'The Data Updated Successfully' });
  }

  showAlertForDeletingdata() {
    this.dialogService.addDialog(AlertComponent, { title: 'DELETE SUBLOCALITY', message: 'The Data Deleted Successfully' });
  }

  addSublocality() {
    this.loading = true;
    let normalizedSublocality = this.normalizeSublocalityName(this.location);
    if (this.emirates == '' || this.emirates == undefined || /^\s*$/.test(this.emirates)) {
      this.newEmirate_err = true;
      this.loading = false;
    } else if (normalizedSublocality === '') {
      this.inputvalidate = true;
      this.loading = false;
    } else {
      if (this.EditObjectId == '' || this.EditObjectId == undefined || this.EditObjectId == null) {
        let reqsublocalityObj = {
          'emiratesId': this.emirates,
          'location': normalizedSublocality,
          'Sublocationlat': this.Sublocationlat,
          'Sublocationlng': this.Sublocationlng,
          'orgId': this.orgId,
          'created_By': this.userId,
          'created_Date': moment.utc().format('YYYY:MM:DD h:mm:ss')
        };
        return this.http.post('/api/addsublocality', reqsublocalityObj).subscribe(res => {
          let sublocalityResponse = res.json();
          if (sublocalityResponse.message == 'This Sublocality Already Exists') {
            this.showDuplicateDialog('This Sublocality Already Exists');
            this.loading = false;
          } else {
            this.reset();
            this.getAllSublocalitydetails();
            this.showAlertForAddingdata();
          }
        }, err => {
          this.loading = false;
          if (err.status != 200) {
            this.alerttxt = 'Unable to load the Value';
            this.getWarningFunction(this.alerttxt);
          }
        });
      } else {
        let reqsublocalityObj = {
          'emirates': this.emirates,
          'location': normalizedSublocality,
          'orgId': this.orgId,
          'objectId': this.EditObjectId,
          'Sublocationlat': this.Sublocationlat,
          'Sublocationlng': this.Sublocationlng,
          'updated_By': this.userId,
          'updated_Date': moment.utc().format('YYYY:MM:DD h:mm:ss')
        };
        return this.http.post('/api/updatesublocality', reqsublocalityObj).subscribe(res => {
          let sublocalityResponse = res.json();
          if (sublocalityResponse.message == 'This Sublocality Already Exists' || sublocalityResponse.message == 'This sublocality Already Exist') {
            this.showDuplicateDialog('This Sublocality Already Exists');
            this.loading = false;
          } else {
            this.reset();
            this.getAllSublocalitydetails();
            this.showAlertForUpdatingdata();
          }
        }, err => {
          this.loading = false;
          if (err.status != 200) {
            this.alerttxt = 'Unable to load the Value';
            this.getWarningFunction(this.alerttxt);
          }
        });
      }
    }
  }

  Editing(index, objectId) {
    this.reset();
    this.EditObjectId = objectId;
    this.btnName = 'Update';
    for (let i = 0; i < this.ListofSublocality.length; i++) {
      if (this.ListofSublocality[i]._id == objectId) {
        this.location = this.ListofSublocality[i].sublocation.toUpperCase();
        this.emirates = this.ListofSublocality[i].emirateid.toString();
        this.emiratesedit = this.ListofSublocality[i].emirateName.toUpperCase();
        this.lat = this.ListofSublocality[i].latitude;
        this.lng = this.ListofSublocality[i].longitude;
        this.Sublocationlat = this.ListofSublocality[i].latitude;
        this.Sublocationlng = this.ListofSublocality[i].longitude;
      }
    }
    this.expanded = true;
  }

  Delete(index, deleteId) {
    if (this.ListofSublocality[index] && this.ListofSublocality[index].status === true) {
      this.msgtext = this.ListofSublocality[index].deleteBlockedReason || this.ToolTip;
      this.getWarningFunction(this.msgtext);
      return false;
    }

    this.reset();
    this.deleteId = deleteId;
    this.Askdelete.options = {
      showButtons: false,
      color: '#4180ab',
      header: 'Delete Sublocality'
    };
    this.Askdelete.show(this.Askdelete.options);
  }

  No() {
    this.Askdelete.hide();
  }

  Yes() {
    this.Askdelete.hide();
    this.loading = true;

    let reqMakeObj = {
      'deleteId': this.deleteId,
      'orgId': this.orgId
    };
    return this.http.post('/api/deleteSublocalityDetails', reqMakeObj).subscribe(res => {
      let subloclityDetails = res.json();
      if (subloclityDetails && subloclityDetails.canDelete === false) {
        this.msgtext = subloclityDetails.reason || this.ToolTip;
        this.getWarningFunction(this.msgtext);
        this.getAllSublocalitydetails();
        return;
      }
      this.showAlertForDeletingdata();
      this.getAllSublocalitydetails();
    }, err => {
      this.loading = false;
      this.msgtext = 'Unable to delete the Value in mysql';
      this.getWarningFunction(this.msgtext);
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/sublocality/sublocality.component.ts